module.exports = __webpack_public_path__ + "img/shipo-itm-logo.a0dad77e.png";